import styled from 'styled-components'

export const DueRow = styled.div`
  display: flex;
  align-items: center;
`

export const DueCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;

  i {
    color: ${(p) => p.theme.uiKit.colors.theme.negative.main};
    margin-right: 5px;
  }
`

export const TooltipContent = styled.span`
  display: flex;
  align-items: center;
`
